module.exports = {
      id: "ic-empty-state-usage",
      viewBox: "0 0 128 118",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-empty-state-usage",
      toString: function () {
        return this.url;
      }
    }